// Testi legali predefiniti della piattaforma (modificabili dal pannello Admin → Testi legali).
// Formato: "# " titolo, "## " sezione, "- " elenco, "Etichetta: testo" in grassetto, riga vuota = nuovo paragrafo.

export const LEGAL_TEXT = `
# Privacy Policy

Piattaforma: Nexora — Game Studio & Store
Titolare del trattamento: Salvatore Raiola (raiolasalvatore95@gmail.com)
Riferimento normativo: Regolamento (UE) 2016/679 (GDPR) e D.Lgs. 196/2003 come modificato dal D.Lgs. 101/2018

## 1. Principio di minimizzazione
Trattiamo solo i dati strettamente necessari al funzionamento della piattaforma (art. 5, par. 1, lett. c GDPR). Puoi giocare senza account e senza fornire alcun dato personale.

## 2. Quali dati trattiamo
- Dati salvati sul tuo dispositivo: Progressi, record, preferenze del tema e impostazioni restano nella memoria locale del browser (localStorage / IndexedDB) e non vengono inviati ai nostri server.
- Dati salvati nel cloud (solo se crei un account): Email, nome visualizzato, monete virtuali, personaggi sbloccati e punteggi in classifica, conservati sui server della piattaforma per sincronizzare i tuoi progressi.
- Accesso con Google: Riceviamo da Google solo identificativo, nome ed email, per associare i progressi al tuo profilo.
- Dati tecnici: Indirizzo IP e informazioni del browser usati temporaneamente per la sicurezza (es. blocco dei tentativi di accesso ripetuti).

## 3. Chiavi API personali (BYOK)
Le chiavi API di Anthropic o OpenAI inserite nell'Area Sviluppatore sono cifrate (AES-GCM) con una chiave del dispositivo non esportabile e restano solo sul tuo browser. Non vengono salvate sui nostri server, non vengono scritte nei log e non vengono cedute a terzi: sono usate solo per la singola richiesta verso il provider ufficiale da te scelto.

## 4. Finalità e base giuridica
- Esecuzione del servizio (art. 6.1.b): Far funzionare giochi, account, classifiche e salvataggi.
- Legittimo interesse (art. 6.1.f): Proteggere la piattaforma da abusi e accessi non autorizzati.
- Nessuna profilazione: Non usiamo i tuoi dati per pubblicità o profilazione.

## 5. Condivisione dei dati
Non vendiamo, non affittiamo e non cediamo i tuoi dati a terzi. I dati sono ospitati da fornitori tecnici (hosting e archiviazione) che agiscono come responsabili del trattamento.

## 6. Conservazione
I dati dell'account restano finché l'account è attivo. Puoi chiederne la cancellazione in qualsiasi momento; i dati locali restano sul tuo dispositivo finché non li cancelli.

## 7. I tuoi diritti
- Accesso (art. 15): Sapere quali dati abbiamo su di te.
- Rettifica (art. 16): Correggere dati inesatti.
- Oblio (art. 17): Cancellare l'account scrivendoci; per i dati locali basta svuotare cache e dati del sito o disinstallare l'app.
- Portabilità (art. 20): Ricevere i tuoi dati in formato leggibile.
- Opposizione e limitazione (artt. 18 e 21): Limitare o opporti al trattamento.
- Reclamo: Rivolgerti al Garante per la protezione dei dati personali (www.garanteprivacy.it).

Per esercitare i tuoi diritti scrivi a raiolasalvatore95@gmail.com: rispondiamo entro 30 giorni.

## 8. Minori
La registrazione di un account è riservata a chi ha almeno 14 anni, come previsto dalla normativa italiana.

## 9. Modifiche
Eventuali aggiornamenti saranno pubblicati in questa pagina con la data di revisione.
`;

export const TERMS_TEXT = `
# Termini di Servizio

## 1. Accettazione
Usando la piattaforma accetti questi Termini. Se non li accetti, ti chiediamo di non usare l'app.

## 2. Giochi gratuiti e solo ricreativi
Tutti i giochi sono gratuiti e hanno scopo esclusivamente ricreativo. Non esistono scommesse, puntate o vincite in denaro reale: la piattaforma non offre in alcun modo gioco d'azzardo.

## 3. Monete, gemme e oggetti virtuali
Monete, gemme, personaggi, punteggi e ogni altro oggetto di gioco sono beni puramente virtuali, senza alcun valore economico. Non possono essere acquistati con denaro reale, venduti, scambiati, convertiti né rimborsati.

## 4. Account giocatore
Sei responsabile della riservatezza delle tue credenziali. Possiamo sospendere gli account che violano questi Termini o che tentano di alterare punteggi, classifiche o monete.

## 5. Contenuti generati dall'Intelligenza Artificiale
Una parte dei giochi, del codice e dei testi è generata automaticamente da modelli di Intelligenza Artificiale. Questi contenuti sono forniti "così come sono": possono contenere errori, imprecisioni o comportamenti imprevisti, e non garantiamo che siano privi di difetti o adatti a scopi specifici.

## 6. Uso corretto
È vietato usare la piattaforma per attività illecite, caricare contenuti offensivi o tentare di aggirare le protezioni di sicurezza.

## 7. Limitazione di responsabilità
Nei limiti consentiti dalla legge, la piattaforma è fornita senza garanzie di disponibilità continua. Non rispondiamo di danni indiretti derivanti dall'uso dei giochi o dei contenuti generati tramite IA. Restano salvi i diritti inderogabili del consumatore.

## 8. Legge applicabile
Questi Termini sono regolati dalla legge italiana.

## 9. Contatti
Per domande scrivi a raiolasalvatore95@gmail.com
`;

export const COOKIE_TEXT = `
# Cookie e Archiviazione Locale

## 1. Nessun cookie di profilazione
Non usiamo cookie di terze parti per profilazione o pubblicità e non tracciamo la tua navigazione su altri siti.

## 2. Cosa salviamo sul tuo dispositivo
Usiamo solo strumenti tecnici necessari al funzionamento dell'app, che per legge non richiedono il consenso:
- localStorage: Preferenze del tema, accettazione di questa informativa, sessione del tuo account giocatore e sessione dell'Area Sviluppatore.
- IndexedDB: Libreria dei giochi creati nello Studio, progressi, record e impostazioni cifrate (incluse le eventuali chiavi API personali).
- PIN dell'Area Sviluppatore: Salvato solo come hash (impronta crittografica non reversibile), mai in chiaro.
- Service Worker e Cache: File dell'app e dei giochi, per farla funzionare anche offline e installarla come app.

## 3. Accesso con Google
Se scegli di accedere con Google, la pagina di accesso di Google può usare i propri cookie tecnici, regolati dall'informativa di Google.

## 4. Come cancellare i dati
Puoi eliminare in qualsiasi momento tutti i dati locali dalle impostazioni del browser (Cancella dati del sito) oppure disinstallando l'app dal telefono.
`;

export const NOTICE_TEXT = `
# Note Legali & Copyright

## Titolare della piattaforma
Salvatore Raiola
Email: raiolasalvatore95@gmail.com

## Supporto e protezione dei dati
Per assistenza, segnalazioni o richieste sulla privacy (anche come referente per la protezione dei dati) scrivi a raiolasalvatore95@gmail.com

## Copyright
Il marchio, il logo, la grafica dell'interfaccia e i giochi originali pubblicati nello Store appartengono al titolare della piattaforma. È vietata la riproduzione senza autorizzazione.

## Crediti
- Grafica 3D: three.js (licenza MIT).
- Componenti dell'interfaccia: Radix UI e shadcn/ui (licenza MIT).
- Icone: Lucide (licenza ISC).
- Generazione assistita: modelli di Intelligenza Artificiale di Anthropic e OpenAI.
`;

export const FOOTER_CONTACTS = 'Contatti: raiolasalvatore95@gmail.com';
